import React, { Component } from 'react';
import { Label, List } from 'semantic-ui-react';

export default class ItemStatsList extends Component {
    render() {
        const {item} = this.props;

        if(!item.Rune && !item.Equipment) {
            return null;
        }

        let slots = '';
        let stats = {};
        let statNames = [];
        let greaterFocus = null;
        let lesserFocus = null;
        let essenceType = null;
        let iLevel = null;

        if(item.Rune) {
            stats = item.Rune.Stats;
            slots = (item.Rune.Slots || []).join(", ");
            statNames = Object.keys(item.Rune.Stats || []);
        } else if(item.Equipment) {
            stats = item.Equipment.Stats;
            slots = item.Equipment.Slot;
            statNames = Object.keys(item.Equipment.Stats || []);

            if(item.Equipment.iLevel) {
                iLevel = <List.Item>
                            <Label size="mini">
                                iLevel
                                <Label.Detail>{item.Equipment.iLevel}</Label.Detail>
                            </Label>
                         </List.Item>
            }

            if(item.Equipment.Focus) {
                greaterFocus = (
                    <List.Item>
                        <Label size="mini">Greater
                            <Label.Detail>{item.Equipment.Focus.Slots.Greater}</Label.Detail>
                        </Label>
                    </List.Item>
                );

                lesserFocus = (
                    <List.Item>
                        <Label size="mini">Lesser
                            <Label.Detail>{item.Equipment.Focus.Slots.Lesser}</Label.Detail>
                        </Label>
                    </List.Item>
                );
            }

            if(item.Equipment.EssenceType) {
                essenceType = <List.Item><Label size="mini">{item.Equipment.EssenceType}</Label></List.Item>
            }
        }

        return (
            <List horizontal={true}>
                <List.Item>
                    <Label size="mini">{slots}</Label>
                </List.Item>
                {iLevel}
                {essenceType}
                {greaterFocus}
                {lesserFocus}
                {statNames.map(s =>
                    <List.Item key={s}>
                        <Label size="mini">{s}
                            <Label.Detail>{stats[s]}</Label.Detail>
                        </Label>
                    </List.Item>
                )}
            </List>
        )
    }
}


// WEBPACK FOOTER //
// ./src/items/index/ItemStatsList.jsx